import { Tooltip, Typography } from '@mui/material'
import React, { memo } from 'react'

const TooltipText = ({ text, ...rest }) => {
  return (
    <Tooltip title={text} arrow>
      <Typography {...rest}>{text}</Typography>
    </Tooltip>
  )
}

export default memo(TooltipText)
